export default __webpack_public_path__ + "static/media/road-F-photo.a1c1e2d8.svg";